// Filter configuration and helper utilities used by the advanced filter UI

export const fieldOptions = [
  'credibility',
  'score',
  'tags',
  'created_by',
  'source',
  'inserted_at',
  'brand',
  'testTarget',
  'priority',
  'model',
  'title',
  'summary',
  'keyword',
];

export const operatorOptions = ['等于', '不等于', '包含', '不包含', '为空', '不为空'];

export const valueOptions = {
  credibility: ['80', '85', '90', '95', '高', '中', '低'],
  score: ['5.0', '6.0', '7.0', '8.0', '9.0', '优', '良', '中', '差'],
  tags: [
    '安全性',
    '儿童',
    '语音交互',
    '医疗',
    '伦理',
    '诊断',
    '智能座舱',
    '安全',
    '极端天气',
    '隐私',
    '金融',
    '教育',
    '合规性',
    'AI教育',
    '客观性评估',
    '高中',
    '自动驾驶',
    '数据安全',
  ],
  created_by: ['测评员-1', '测评员-2', '审核员-1', 'David', 'Mike', 'Sarah', '李老师', '张先生', '王工程师'],
  source: ['AI toy', '医疗AI研究中心', '交通安全研究院', '未来教育实验室', '智能理财研究部', 'ATtoy', '无人驾驶实验室', '安全评测中心'],
  inserted_at: ['今天', '昨天', '本周', '上周', '本月', '上月'],
  brand: ['儿童智能', 'Medical-AI', '汽车智能', '教育AI', '金融科技'],
  testTarget: ['AI玩具', '大型语言模型', '智能座舱', '自动驾驶系统'],
  priority: ['高', '中', '低'],
  model: ['伴学宝', 'MedGPT', '汽车助手', '教育助手', '理财顾问'],
  title: [],
  summary: [],
  keyword: ['安全', 'AI', '语音', '医疗', '自动驾驶', '金融', '教育', '隐私保护', '评估', '风险', '测试'],
  场景: ['聊天场景', '客服咨询', '文档编辑', '内容生成', '教育辅导', '医疗咨询', '金融咨询'],
  标签: ['安全性', 'AI', '语音交互', '医疗', '教育', '金融'],
  作者: ['测评员-1', '测评员-2', 'David', '李老师', '张先生'],
  来源: ['AI toy', '医疗AI研究中心', '交通安全研究院', '未来教育实验室'],
};

export const fieldNameMap = {
  credibility: '可信度',
  score: '评分',
  tags: '标签',
  created_by: '创建者',
  source: '来源',
  inserted_at: '创建时间',
  brand: '品牌',
  testTarget: '测试目标',
  priority: '优先级',
  model: '模型',
  title: '标题',
  summary: '摘要',
  keyword: '关键词',
  可信度: 'credibility',
  评分: 'score',
  标签: 'tags',
  创建者: 'created_by',
  来源: 'source',
  创建时间: 'inserted_at',
  品牌: 'brand',
  测试目标: 'testTarget',
  优先级: 'priority',
  模型: 'model',
  标题: 'title',
  摘要: 'summary',
  关键词: 'keyword',
  Credibility: 'credibility',
  Score: 'score',
  Tags: 'tags',
  CreatedBy: 'created_by',
  Source: 'source',
  CreatedAt: 'inserted_at',
  Brand: 'brand',
  TestTarget: 'testTarget',
  Priority: 'priority',
  Model: 'model',
  Title: 'title',
  Summary: 'summary',
  Keyword: 'keyword',
  created_time: 'inserted_at',
  author: 'created_by',
  场景: 'scenario',
};

export const normalizeFieldName = (fieldName) => {
  if (!fieldName) return 'keyword';
  const normalizedName = fieldNameMap[fieldName] || fieldName.toLowerCase();
  switch (normalizedName) {
    case 'author':
    case 'creator':
    case '作者':
      return 'created_by';
    case 'source':
    case '来源':
      return 'source';
    case 'time':
    case 'date':
    case 'created_time':
    case '创建时间':
      return 'inserted_at';
    case 'tag':
    case '标签':
      return 'tags';
    case 'confidence':
    case '可信度':
      return 'credibility';
    default:
      return normalizedName;
  }
};

export const groupFieldOptions = ['标签', '创建者', '来源', '优先级', '测试目标', '创建时间'];

export const sortFieldOptions = [{ value: 'like_count', label: '点赞数' }];

export const sortDirectionOptions = [
  { value: 'asc', label: '升序' },
  { value: 'desc', label: '降序' },
];

export const initialFilterState = {
  visible: false,
  step: 'filter',
  filterConfig: {
    conditions: [],
  },
  groupConfig: {
    fields: [],
  },
  sortConfig: {
    fields: [],
  },
};

export const processCardFieldValue = (card, field) => {
  if (!card) return null;

  switch (field) {
    case 'credibility':
      return card.credibility ? card.credibility.toString() : '0';
    case 'score':
      return card.score ? card.score.toString() : '0';
    case 'tags':
      return Array.isArray(card.tags) ? card.tags : [];
    case 'created_by':
      return card.created_by || (card.author && card.author.name) || '';
    case 'source':
      return card.source || '';
    case 'inserted_at':
      if (card.inserted_at) {
        if (card.inserted_at.seconds) {
          const date = new Date(card.inserted_at.seconds * 1000);
          return date.toISOString();
        }
        if (typeof card.inserted_at === 'string') {
          return card.inserted_at;
        }
      }
      return '';
    case 'title':
      return card.title || '';
    case 'summary':
      return card.summary || card.response_summary || '';
    case 'keyword':
      return [
        card.title || '',
        card.summary || card.response_summary || '',
        ...(Array.isArray(card.tags) ? card.tags : []),
        card.created_by || (card.author && card.author.name) || '',
        card.source || '',
      ].join(' ');
    default:
      return card[field] || '';
  }
};

export const filterCardsByConditions = (cards, filterConfig) => {
  if (!filterConfig || !Array.isArray(filterConfig.conditions) || filterConfig.conditions.length === 0) {
    return cards;
  }

  return cards.filter((card) =>
    filterConfig.conditions.every((condition) => {
      const cardValue = processCardFieldValue(card, condition.field);

      if (condition.operator === '为空') {
        if (Array.isArray(cardValue)) {
          return cardValue.length === 0;
        }
        return cardValue === null || cardValue === undefined || cardValue === '';
      }

      if (condition.operator === '不为空') {
        if (Array.isArray(cardValue)) {
          return cardValue.length > 0;
        }
        return cardValue !== null && cardValue !== undefined && cardValue !== '';
      }

      const conditionValue = condition.value ?? (condition.values && condition.values[0]);
      if (conditionValue === null || conditionValue === undefined) {
        return true;
      }

      switch (condition.operator) {
        case '等于':
        case 'EQ':
          if (Array.isArray(cardValue)) {
            return cardValue.some((val) => val.toString().toLowerCase() === conditionValue.toString().toLowerCase());
          }
          return cardValue.toString().toLowerCase() === conditionValue.toString().toLowerCase();
        case '不等于':
        case 'NEQ':
          if (Array.isArray(cardValue)) {
            return !cardValue.some((val) => val.toString().toLowerCase() === conditionValue.toString().toLowerCase());
          }
          return cardValue.toString().toLowerCase() !== conditionValue.toString().toLowerCase();
        case '包含':
        case 'LIKE':
          if (Array.isArray(cardValue)) {
            return cardValue.some((val) => val.toString().toLowerCase().includes(conditionValue.toString().toLowerCase()));
          }
          return cardValue.toString().toLowerCase().includes(conditionValue.toString().toLowerCase());
        case '不包含':
        case 'NOT_IN':
          if (Array.isArray(cardValue)) {
            return !cardValue.some((val) => val.toString().toLowerCase().includes(conditionValue.toString().toLowerCase()));
          }
          return !cardValue.toString().toLowerCase().includes(conditionValue.toString().toLowerCase());
        case 'IS_NULL':
          if (Array.isArray(cardValue)) {
            return cardValue.length === 0;
          }
          return cardValue === null || cardValue === undefined || cardValue === '';
        case 'IS_NOT_NULL':
          if (Array.isArray(cardValue)) {
            return cardValue.length > 0;
          }
          return cardValue !== null && cardValue !== undefined && cardValue !== '';
        default:
          return true;
      }
    })
  );
};



